import React from "react";
import AdditionalContent from "@nvs/gatsby-theme-leap-core/src/components/domains/home/additional-content/additional-content";
import { RichText } from "@nvs/gatsby-theme-leap-core/src/components/hoc/components";
import useTranslation from "@nvs/gatsby-theme-leap-core/src/hooks/useTranslation";
import Section from "@nvs/gatsby-theme-leap-core/src/components/hoc/components/section/section";
import Button from "@nvs/gatsby-theme-leap-core/src/components/hoc/components/button";
import {
	EventAction,
	EventCategory,
	EventKeys,
	EventType,
} from "@nvs/gatsby-theme-leap-core/src/services/analytics-interfaces";
import { AdherenceIcon } from "@nvs/gatsby-theme-leap-core/src/assets/images/adherence-icon";
import { UserActionType } from "@nvs/gatsby-theme-leap-core/src/components/hoc/components/analytics";
import { NovartisPatientSupportSVG } from "@nvs/gatsby-theme-leap-core/src/assets/images/novartisPatientSupportSvg";
import Panel from "../../../../../components/panel";
import { FTOIcon } from "@nvs/gatsby-theme-leap-core/src/assets/images/fto-icon";
import { CopayIcon } from "@nvs/gatsby-theme-leap-core/src/assets/images/copay-icon";
import Tooltip from "@nvs/gatsby-theme-leap-core/src/components/hoc/components/tooltip";

const HomeContent: React.FC<{ next: Function }> = ({ next }) => {
	const { t } = useTranslation();
	return (
		<Section>
			<Panel>
				<Section>
					<div className='text-left lg:text-center text-2xl'>
						<RichText html={t("pages.welcome.description.part1")} />
					</div>
					<Button
						onClick={next}
						analytics={{
							eventType: EventType.SimpleEvent,
							eventLabel: EventAction.Click,
							eventCategory: EventCategory.Landing,
							userActionType: UserActionType.click,
							eventArgs: {},
							[EventKeys.PageRequestTime]: new Date().getTime(),
						}}
					>
						{t("pages.welcome.getStarted")}
					</Button>
					<div className='flex flex-col lg:flex-row items-center gap-2 text-center text-2xl'>
						<RichText html={t("pages.welcome.description.part2")} />
						<NovartisPatientSupportSVG className='text-font max-w-[275px] lg:max-w-none' />
						<RichText html={t("pages.welcome.description.part3")} />
					</div>
					<div className='flex flex-col lg:flex-row divide-y-2 lg:divide-x-2 lg:divide-y-0 divide-[#FD6B0D]'>
						<div className='flex flex-col items-center gap-3 text-lg text-center py-8 first:pt-0 last:pb-0 lg:px-8 lg:py-0 lg:first:pl-0 lg:last:pr-0 grow shrink basis-0'>
							<div aria-hidden='true' className='flex gap-1'>
								<AdherenceIcon className='stroke-icon h-16' />
								<Tooltip
									title={t(`pages.welcome.tooltips.adherence.title`)}
									icon='?'
									modal={true}
									className='w-4 h-4 inline-flex justify-center items-center rounded-full text-xs text-font-contrast bg-brand'
								>
									<RichText
										html={t(`pages.welcome.tooltips.adherence.message`)}
									/>
								</Tooltip>
							</div>
							<div className='flex flex-col items-start gap-3'>
								<div className='text-font text-left text-lg font-bold'>
									<RichText html={t(`services.adherence.title`)} />
								</div>
								<div className='text-font text-left text-base'>
									<RichText html={t(`services.adherence.description`)} />
								</div>
							</div>
						</div>
						<div className='flex flex-col items-center gap-3 text-lg text-center py-8 first:pt-0 last:pb-0 lg:px-8 lg:py-0 lg:first:pl-0 lg:last:pr-0 grow shrink basis-0'>
							<div aria-hidden='true' className='flex gap-1'>
								<CopayIcon className='stroke-icon h-16' />
								<Tooltip
									title={t(`pages.welcome.tooltips.copay.title`)}
									icon='?'
									modal={true}
									className='w-4 h-4 inline-flex justify-center items-center rounded-full text-xs text-font-contrast bg-brand'
								>
									<RichText html={t(`pages.welcome.tooltips.copay.message`)} />
								</Tooltip>
							</div>
							<div className='flex flex-col items-start gap-3'>
								<div className='text-font text-left text-lg font-bold'>
									<RichText html={t(`services.copay.title`)} />
								</div>
								<div className='text-font text-left text-base'>
									<RichText html={t(`services.copay.description`)} />
								</div>
							</div>
						</div>
						<div className='flex flex-col items-center gap-3 text-lg text-center py-8 first:pt-0 last:pb-0 lg:px-8 lg:py-0 lg:first:pl-0 lg:last:pr-0 grow shrink basis-0'>
							<div aria-hidden='true' className='flex gap-1'>
								<FTOIcon className='fill-icon h-16' />
								<Tooltip
									title={t(`pages.welcome.tooltips.fto.title`)}
									icon='?'
									modal={true}
									className='w-4 h-4 inline-flex justify-center items-center rounded-full text-xs text-font-contrast bg-brand'
								>
									<RichText html={t(`pages.welcome.tooltips.fto.message`)} />
								</Tooltip>
							</div>
							<div className='flex flex-col items-start gap-3'>
								<div className='text-font text-left text-lg font-bold'>
									<RichText html={t(`services.fto.title`)} />
								</div>
								<div className='text-font text-left text-base'>
									<RichText html={t(`services.fto.description`)} />
								</div>
							</div>
						</div>
					</div>
				</Section>
			</Panel>
			<AdditionalContent />
		</Section>
	);
};

export default HomeContent;
